module.exports = __webpack_public_path__ + "img/raduga-birds.6948b898.png";